// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ww6CTqKqFbTUgijCmt0k{display:none}.ZmxnvK_vwvG98LATZiKk>.v45LOrN98EEnInU7pi20{color:#000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hidden": "ww6CTqKqFbTUgijCmt0k",
	"ltgt": "ZmxnvK_vwvG98LATZiKk",
	"ignoreThis": "v45LOrN98EEnInU7pi20"
};
export default ___CSS_LOADER_EXPORT___;
